import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../servicios/api/api.service';
import { fuenteI } from '../../../modelos/fuentes.interface';
import { NivelSuperv } from 'src/app/modelos/nivelSupervicon.interface';
import { TipoCredito } from 'src/app/modelos/tipoCredito.interface';
import { SolucViv } from 'src/app/modelos/solucionViv.interface';
import { RangViv } from 'src/app/modelos/rangoViv.interface';
import { Tenedor } from 'src/app/modelos/tenedor.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Fte_Parm } from 'src/app/modelos/fuenteParam';
import { VarParamI } from 'src/app/modelos/VariableParametrica';
import { VariableI } from 'src/app/modelos/variable';
import { ToastrService } from 'ngx-toastr';
import { FuenteParametroI } from 'src/app/modelos/FuenteParametro';
import { FuenteVariableI } from 'src/app/modelos/FuenteVariable';

@Component({
  selector: 'app-adminvariableschv',
  templateUrl: './adminvariableschv.component.html',
  styleUrls: ['./adminvariableschv.component.css']
})
export class AdminvariableschvComponent implements OnInit {

  btnguardar : Boolean;
  nuevoFteParam : Boolean;
  editarFteParam : Boolean;
  datosEditFuente : fuenteI;
  FuenteParametrica : FuenteParametroI[];
  FuenteParametricaEditar : FuenteParametroI = new FuenteParametroI;
  NombreParametricaEditar : string = "";
  ItemsFuenteParametrica : FuenteVariableI[];
  FuenteVariableEditar : FuenteVariableI = new FuenteVariableI;
  NombreVariableEditar : string = "";

  verParametricas: Boolean = false;
  verItemsParametricas: Boolean = false;

  page : number;

  @ViewChild('closemodalconfirma') closemodalconfirma: ElementRef;
  @ViewChild('openmodalitems') openmodalitems: ElementRef;
  @ViewChild('closemodalitems') closemodalitems: ElementRef;
  @ViewChild('openmodalconfirvaria') openmodalconfirvaria: ElementRef;
  @ViewChild('closemodalconfirvaria') closemodalconfirvaria: ElementRef;

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService
    ) { }

  ngOnInit(): void {
    let fuenteId = this.activerouter.snapshot.paramMap.get('id');
    this.btnguardar = true;
    this.nuevoFteParam = false;
    this.editarFteParam = false;

    this.datosEditFuente = new fuenteI;
    this.api.getFuenteById(fuenteId).subscribe(data0=>{
      this.datosEditFuente = data0;
    });

    this.api.getParametrosFte(fuenteId).subscribe(data1=>{
      this.FuenteParametrica = data1;
    });
  }

  Regresar(){
    this.router.navigate(['variableschv']);
  }

  CambioObligatoriedad(FtePara:FuenteParametroI){
    this.NombreParametricaEditar = FtePara.parametrica.nombre;
    this.FuenteParametricaEditar = FtePara;
  }

  guardar(){
    this.btnguardar = false;
    this.api.guardarFteParam(this.FuenteParametricaEditar).subscribe(data=>{
      if(data){
        this.toastr.success('Cambio guardado.', 'OK!');
        this.closemodalconfirma.nativeElement.click();
        this.ngOnInit();
      }
    },error=>{
      console.log(error);
    });
  }

  ItemsParametrica(FtePara:FuenteParametroI){
    this.btnguardar = true;
    this.openmodalitems.nativeElement.click();
    this.NombreParametricaEditar = FtePara.parametrica.nombre;
    this.FuenteParametricaEditar = FtePara;
    this.api.getVariablesFte(this.FuenteParametricaEditar).subscribe(data2=>{
      this.ItemsFuenteParametrica = data2;
    });
  }

  CambioObligatoriedadItem(FteVaria: FuenteVariableI) {
    this.FuenteVariableEditar = { ...FteVaria };
    this.NombreVariableEditar = FteVaria.variable.nombre;
    this.closemodalitems.nativeElement.click();
    this.closemodalconfirma.nativeElement.click();
    this.openmodalconfirvaria.nativeElement.click();
  }

  guardarItem() {
    this.btnguardar = false;
    this.api.guardarFteVaria(this.FuenteVariableEditar).subscribe(data3 => {
      if (data3) {
        this.toastr.success('Cambio guardado.', 'OK!');
        this.closemodalconfirvaria.nativeElement.click();
        this.openmodalitems.nativeElement.click();
        this.ItemsParametrica(this.FuenteParametricaEditar);
      }
    });
  }


  regresar(){
    this.router.navigate(['variableschv']);
  }

}
